import React from 'react';
import { Flex, Box, Heading } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

export const BlockedBrowserPopup = () => {
    return (
        <Flex
            height="100vh"
            width="100vw"
            justify="center"
            align="center"
            flexDir="column">
            <Box padding="4" borderLeft="4px solid black" marginBottom="4">
                <Heading size="lg" color="ecp.900">
                    Blocked popups
                </Heading>
                <Heading size="sm" color="ecp.900">
                    Your browser blocks signing popup. Please allow our domain
                    showing popups and then{' '}
                    <Link to="/login" style={{ textDecoration: 'underline' }}>
                        sign in
                    </Link>
                    .
                </Heading>
            </Box>
        </Flex>
    );
};
